var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('owner-reservation-setup',{attrs:{"setup_parameter":_vm.SETUP_PARAMETER_OWNER_STATEMENT_SETUP}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }